// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider__container--2_j","overflowSlider":"Slider__overflowSlider--1X1","one":"Slider__one--38x"};